module.exports = "<div id=tpl_refer> <div class=u-row> <div id=content-tree class=u-col-4> <u-tree id=classTree class=form-control params='data:{model:$root.classTreemodel,treeSetting:$root.treeOption},\n    umeta:{\"id\":\"classTreeDemo\",\"data\":\"model\",\"idField\":\"id\",\"pidField\":\"pid\",\"nameField\":\"title\",\"setting\":\"treeSetting\"}'> </u-tree> </div> <div class=u-col-8> <div class=\"u-row margin-top-15\"> <u-grid params=\"config: gridconfig\"></u-grid> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/rejectSelect/index.html
// module id = 361
// module chunks = 144